const LocalizzazioneSchema = {
  title: 'Localizzazione',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'title', 
        'titleDimension',
        'titleAlignment',
        'tipoElementi',
        'dotsPosition',
        'description', 
        'titlePlace', 
        'street', 
        'zipCode', 
        'city',         
        'coordinates'
      ],
    },
    {
      id: 'style',
      title: 'Stile',
      fields: [
        'mapPosition', 
        'cardBackground'
      ],
    },
  ],
  properties: {
    title: {
      title: 'Titolo',
      type: 'string',
    },
    titleDimension: {
      title: 'Dimensioni titolo',     
      type: 'string',
      factory: 'Choice',
      choices: [           
        ['h2', 'H2'],
        ['h3', 'H3'],
        ['h4', 'H4'],
      ],
      default: 'h2',
    },  
    titleAlignment: {
      title: 'Allineamento titolo',     
      type: 'string',
      factory: 'Choice',
      choices: [           
        ['left', 'Titolo a sinistra'],
        ['center', 'Titolo al centro'],
        ['right', 'Titolo a destra'],
      ],
      default: 'left',
    },    
    tipoElementi: {
        title: 'Tipo elementi decorativi',
        widget: 'select',
        choices: [
          ['baby', 'Bambino'],    
          ['circle', 'Cerchio'],
          ['spinner', 'Spinner'],         
        ],
        default: 'baby',
      },
    dotsPosition: {
        title: 'Posizione elementi decorativi',
        widget: 'select',
        choices: [
          ['no-points', 'Senza'],    
          ['before', 'Prima del titolo'],
          ['after', 'Dopo il titolo'],
          ['both', 'Prima e dopo il titolo'],
        ],
        default: 'both',
      },
    description: {
      title: 'Descrizione',
      type: 'string',
      widget: 'richtext',
      description: 'Descrizione dettagliata del luogo. Supporta formattazione HTML.',
    },
    titlePlace: {
      title: 'Nome luogo',
      type: 'string',
    },
    street: {
      title: 'Via',
      type: 'string',
    },
    zipCode: {
      title: 'CAP',
      type: 'string',
    },
    city: {
      title: 'Città',
      type: 'string',
    },
    mapPosition: {
      title: 'Posizione della mappa',
      type: 'string',
      factory: 'Choice',
      choices: [
        ['left', 'Sinistra'],
        ['right', 'Destra'],
      ],
      default: 'left',
    },
    coordinates: {
      title: 'Coordinate (lat, lng)',
      type: 'array',
      items: {
        type: 'number',
      },
      default: [44.809984, 10.323001], 
      widget: 'hidden', // Nascondi il campo dalla form
    },
    cardBackground: {
      title: 'Sfondo',
      description: 'Scegli il colore di sfondo per il blocco',
      type: 'string',
      factory: 'Choice',
      choices: [
        ['no-background', 'Nessuno sfondo'],
        ['blue-background', 'Azzurro'],
        ['pastel-blue-background', 'Azzurro pastello'],
      ],
      default: 'no-background',
    },
  },
  required: ['title', 'street', 'zipCode', 'city'], // Rendiamo obbligatori i campi dell'indirizzo
};

export default LocalizzazioneSchema;